import { PrivateSchemaPropertyType, createSchemaConfig } from '../helpers/schema.helpers'
import { InsightsFormatterType } from '../types/schema.types'
import { Metrics, Dimensions } from './insightsPortalMissingImage90DayRetailerInsights.types'

export { Metrics, Dimensions }

export const schemaConfig = createSchemaConfig({
  metrics: Metrics,
  dimensions: Dimensions,
  metricsConfig: {
    [Metrics.SUM_CONVERSION_GMV]: {
      formatter: InsightsFormatterType.Currency,
      label: 'insightsPortalDomain.searchDashboard.missingImage.header.conversionGMV',
    },
    [Metrics.SUM_IMPRESSIONS]: {
      formatter: InsightsFormatterType.Integer,
      label: 'insightsPortalDomain.searchDashboard.missingImage.header.searchImpressions',
    },
    [Metrics.MAX_UPDATED_AT_DATE_TIME_UTC]: {
      formatter: InsightsFormatterType.Date,
      private: true,
    },
  },
  dimensionsConfig: {
    [Dimensions.ITEM_NAME]: {
      label: 'insightsPortalDomain.searchDashboard.missingImage.header.itemName',
    },
    [Dimensions.WAREHOUSE]: {
      label: 'insightsPortalDomain.filters.retailers.label',
    },
    [Dimensions.PRODUCT_ID]: {
      label: 'insightsPortalDomain.searchDashboard.missingImage.header.productID',
      private: PrivateSchemaPropertyType.DataExplorerFilters,
      formatter: (value: number) => Math.round(value).toString(),
    },
    [Dimensions.WAREHOUSE_ID]: {
      label: 'insightsPortalDomain.filters.retailerIds.label',
      private: true,
    },
    [Dimensions.PRODUCT_UPC_CODE]: {
      label: 'insightsPortalDomain.searchDashboard.missingImage.header.productUpcCode',
      private: PrivateSchemaPropertyType.DataExplorerFilters,
    },
    [Dimensions.DEPARTMENT]: {
      label: 'insightsPortalDomain.searchDashboard.missingImage.header.department',
      private: PrivateSchemaPropertyType.DataExplorerFilters,
    },
    [Dimensions.PRODUCT_RRC_CODE]: {
      label: 'insightsPortalDomain.searchDashboard.missingImage.header.productRrcCode',
    },
  },
  dimensionGroupings: [
    {
      label: 'insightsPortalDomain.filters.stores',
      dimensions: [Dimensions.WAREHOUSE],
    },
    {
      label: 'insightsPortalDomain.filters.groups.products',
      dimensions: [
        Dimensions.ITEM_NAME,
        Dimensions.PRODUCT_ID,
        Dimensions.PRODUCT_UPC_CODE,
        Dimensions.DEPARTMENT,
        Dimensions.PRODUCT_RRC_CODE,
      ],
    },
  ],
})
